import styled from 'styled-components';
import Sidebar from '~/components/sidebar';
import Header from '~/components/header';

import { ContainerProvider } from './container-context';
import { useState } from 'react';

const Container = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <ContainerProvider
      isSidebarOpen={isSidebarOpen}
      setSidebarOpen={setSidebarOpen}
    >
      <S.Container isSidebarOpen={isSidebarOpen}>
        <Header />
        <div>
          <S.Sidebar isSidebarOpen={isSidebarOpen} />
          <S.Content isSidebarOpen={isSidebarOpen}>{children}</S.Content>
        </div>
      </S.Container>
    </ContainerProvider>
  );
};

const S = {
  Container: styled.main`
    --sidebar-width: 280px;
    --header-height: 60px;
    background: ${({ theme }) => theme.colors.body};
    min-height: 100vh;
    height: 100%;
    margin: 0;
    position: relative;
  `,
  Sidebar: styled(Sidebar)`
    position: absolute;
    left: ${({ isSidebarOpen }) =>
      isSidebarOpen ? '0' : 'calc(-1 * var(--sidebar-width))'};
    top: var(--header-height);
    width: var(--sidebar-width);
    z-index: 99;
    transition: left 200ms;

    @media (min-width: ${({ theme }) => theme.screens.md}) {
      position: fixed;
      left: 0;
      top: var(--header-height);
      bottom: 0;
      width: var(--sidebar-width);
    }
  `,
  Content: styled.section`
    flex: 1;
    position: fixed;
    left: 0;
    top: var(--header-height);
    bottom: 0;
    right: 0;
    overflow: auto;
    padding: 3rem 1.75rem;
    transition: left 200ms;

    @media (min-width: ${({ theme }) => theme.screens.md}) {
      left: var(--sidebar-width);
    }
  `,
};

export default Container;
